import { JwtHelperService } from '@auth0/angular-jwt';

const jwtHelper = new JwtHelperService();

export function getRoleFromToken(): string {
  const token = localStorage.getItem('token');
  if (!token) return '';
  try {
    return jwtHelper.decodeToken(token)?.user?.rol || '';
  } catch {
    return '';
  }
}
